export default function isValidDate(dateObject: Date | string | number | null) {
    if (dateObject === null) {
        return false
    } else {
        const date = new Date(dateObject)
        return !isNaN(date.getTime())
    }
}
